import React from "react";
import { Link } from "react-router-dom";
import "./Dashboard.css";

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard-content">
      <div className="content-header">
        <h2>환영합니다!</h2>
        <p>웨딩 사이트 관리자 대시보드입니다.</p>
      </div>

      <div className="content-body">
        <div className="dashboard-stats">
          <div className="stat-card">
            <h3>총 방문자</h3>
            <p>0</p>
          </div>
          <div className="stat-card">
            <h3>오늘의 방문자</h3>
            <p>0</p>
          </div>
          <div className="stat-card">
            <h3>허용된 이메일</h3>
            <p>0</p>
          </div>
        </div>

        <div className="management-menu">
          <h3>관리 메뉴</h3>
          <div className="menu-grid">
            <Link to="/admin/wedding-info" className="menu-card">
              <div className="menu-icon">💍</div>
              <h4>웨딩 정보</h4>
              <p>신랑신부 정보, 예식 정보 관리</p>
            </Link>

            <Link to="/admin/messages" className="menu-card">
              <div className="menu-icon">💬</div>
              <h4>문구 관리</h4>
              <p>초대장 메시지, 부제목 등 문구 관리</p>
            </Link>

            <Link to="/admin/gallery" className="menu-card">
              <div className="menu-icon">🖼️</div>
              <h4>갤러리 관리</h4>
              <p>사진 업로드, 삭제, 순서 변경</p>
            </Link>

            <Link to="/admin/page-settings" className="menu-card">
              <div className="menu-icon">⚙️</div>
              <h4>페이지 설정</h4>
              <p>페이지 표시/숨김 설정</p>
            </Link>

            <Link to="/admin/emails" className="menu-card">
              <div className="menu-icon">✉️</div>
              <h4>이메일 관리</h4>
              <p>관리자 이메일 추가/삭제</p>
            </Link>

            <Link to="/admin/guestbook" className="menu-card">
              <div className="menu-icon">💬</div>
              <h4>축하한마디 관리</h4>
              <p>방명록 메시지 관리</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
